import styled from "styled-components";

import { CheckBox } from "shared/atoms/inputs";
import { StyledInput } from "shared/atoms/inputs/StyledInputs";

const Input = styled(StyledInput)`
  max-width: 35px;
  height: 30px;
  padding: ${props => props.theme.spacing.S_5};
  margin: 0 ${props => props.theme.spacing.S_5};
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  &[type="number"] {
    appearance: textfield;
  }
`;

const StyledCheckBox = styled(CheckBox)`
  margin: 8px 0;
  ${props => props.theme.belowBreakpoint} {
    padding: 8px 0;
  }
`;

export { Input, StyledCheckBox };
